export const ORDER_LIST_MANAGER_COLUMN = "ORDER_LIST_MANAGER_COLUMN";